<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
  components: {
    // Multiselect
  },
  name: "ItemCategoryGroup",
  data() {
    return {
      submitted: false,
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          sortable: true,
        },
      ],
      form: {
        id: 0,
        name: "",
        description: "",
      },
      indexSelected: -1,
      tableBusy: false,
    };
  },
  computed: {
    rows() {
      if (this.filter) {
        return this.totalRows;
      }
      return this.tableData.length;
    },
  },
  validations: {
    form: {
      name: { required },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getItemCategoryGroup() {
      this.tableBusy = true;
      await this.$store
        .dispatch("itemcategorygroup/GetItemCategoryGroup")
        .then((res) => {
          res.data.map((item) => {
            item.showPO = false;
            item.technicalUsers = [];
            item.technicalLoading = false;
          });
          this.tableData = res.data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
      this.tableBusy = false;
    },
    getItemCat(props) {
      this.$emit("getItemCat", props.id);
    },
  },
};
</script>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex row align-items-center mb-2">
          <div class="col-md-4 hover-toggle">
            <div class="d-flex align-items-center">
              <h4 class="card-title m-0 me-1">Group Category</h4>
            </div>
          </div>
          <div class="col-md-8">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-end"
            >
              <label class="d-inline-flex align-items-center mb-0">
                Search:
                <b-form-input
                  autocomplete="off"
                  v-model="filter"
                  type="search"
                  placeholder="Search..."
                  class="form-control form-control-sm ms-2 me-1"
                ></b-form-input>
                <b-form-select
                  class="form-select form-select-sm w-auto"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                ></b-form-select>
              </label>
            </div>
          </div>
        </div>
        <div class="table-responsive mb-0">
          <b-table
            class="datatables"
            :items="tableData"
            :fields="fields"
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="tableBusy"
            @filtered="onFiltered"
            bordered
            outlined
            hover
            striped
            show-empty
          >
            <template #empty="scope">
              <div class="text-center">{{ scope.emptyText }}</div>
            </template>
            <template #table-busy>
              <div class="d-flex justify-content-center align-items-center">
                <div class="preloader-component me-2">
                  <div class="status">
                    <div class="spinner-chase w-20px h-20px">
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                      <div class="chase-dot"></div>
                    </div>
                  </div>
                </div>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(name)="row">
              <a
                href="javascript:void(0)"
                @click="getItemCat(row.item)"
                class="text-white hover-underline"
              >
                {{ row.value }}
              </a>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
